import React from "react";

const TableHeaderCell = ({ children }) => {
    return (
        <th className="table__cell" >
            {children}
        </th>
    );
};

TableHeaderCell.propTypes = {};
TableHeaderCell.defaultProps = {};

export default TableHeaderCell;
